import { BannerData } from '../lib/bannerData';
import BannerDescription from './BannerDescription';
import BannerTitle from './BannerTitle';

interface BannerContentProps {
  currentBanner: BannerData;
}

const BannerContent = ({ currentBanner }: BannerContentProps) => {
  return (
    <div className='flex w-full flex-1 flex-col pt-[32px] sm:pt-[28px]'>
      <BannerTitle currentBanner={currentBanner} />
      <BannerDescription />
    </div>
  );
};

export default BannerContent;
